import type { ReactNode } from 'react';
import { useEffect } from 'react';
import loginSplash from '../../../assets/login_splash.png';

/** The shell every auth page renders inside: animated backdrop, splash image and centred content. */
export function AuthLayout({ children }: { children: ReactNode }) {
  useEffect(() => {
    document.body.classList.remove('overflow-hidden');
  }, []);

  return (
    <div className="bg-gray-100 sm:bg-none">
      <div className="relative z-10 flex min-h-screen flex-col px-6 py-8 sm:justify-center lg:px-8">
        <div className="auth-bg" />
        <div className="auth-bg auth-bg-reverse" />
        <div className="auth-bg" />
        <div className="z-10">{children}</div>
        <img
          className="absolute bottom-0 left-0 z-1 hidden h-full w-full lg:block"
          src={loginSplash}
          alt=""
        />
      </div>
    </div>
  );
}
